export const formatCountdown = (time: number) => {
    const ts = Math.floor(time / 1000);
    const d = String(Math.floor(ts / 3600 / 24)).padStart(2, '0');
    const h = String(Math.floor((ts / 3600) % 24)).padStart(2, '0');
    const m = String(Math.floor((ts / 60) % 60)).padStart(2, '0');
    const s = String(Math.floor(ts % 60)).padStart(2, '0');
    return { d, h, m, s };
};
